export default "__VITE_ASSET__DJW_AxWi__"